/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-array-index-key */
import React, { Component, createRef } from 'react';
import ReactS3Uploader from 'react-s3-uploader';
import './styles.scss';
import { config } from '../../environment';

export class SurveyQuestion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadError: false,
      uploading: false,
    };
    this.s3Uploader = createRef();
  }

  isSelected = (option) => {
    if (!('answer' in this.props.surveyQuestions[this.props.name])) return false;
    const { answer } = this.props.surveyQuestions[this.props.name];

    if (answer instanceof Set || answer instanceof Array) {
      return answer instanceof Set ? answer.has(option) : answer.includes(option);
    }
    return answer !== null && answer.toString() === option.toString();
  }

  uploadSuccess = (info) => {
    this.setState({ uploadError: false, uploading: false });
    this.props.optionSelected(this.props.surveyQuestions, this.props.name, this.props.type, info.fileKey);
  }

  uploadError = () => {
    try {
      this.s3Uploader.current.value = '';
    } catch {
      console.log('s3 uploader ref is unset');
    }
    this.setState({ uploadError: true, uploading: false });
    this.props.optionSelected(this.props.surveyQuestions, this.props.name, this.props.type, '');
  }

  renderShortAnswer = () => {
    const answer = this.props.surveyQuestions[this.props.name]?.answer;
    return (
      <div className="surveyOptionContainer">
        <input type="text"
          className="textVal"
          placeholder="Enter text here."
          value={(answer && answer !== 'null') ? answer : ''}
          onChange={(e) => {
            this.props.optionSelected(this.props.surveyQuestions, this.props.name, this.props.type, e.target.value);
          }}
        />
      </div>
    );
  }

  renderMultiple = () => {
    return this.props.options.map((option, i) => {
      return (
        <div className="surveyOptionContainer" key={i}>
          <div
            role="button"
            tabIndex={0}
            className={`surveyOptionButton ${this.isSelected(option) && 'surveySelected'}`}
            onClick={() => this.props.optionSelected(this.props.surveyQuestions, this.props.name, this.props.type, option)}
          />
          <p className="surveyOptionText">{option}</p>
        </div>
      );
    });
  }

  displayImportFileStatus = () => {
    if (this.state.uploading) return 'uploading...';
    if (this.s3Uploader?.current?.value) {
      return this.s3Uploader.current.value.replace('C:\\fakepath\\', '');
    } else if (this.props.surveyQuestions[this.props.name]?.answer) {
      return 'You\'ve already uploaded an image, but you can upload a new one if you want!';
    } else return 'No file chosen';
  }

  renderImport = () => {
    return (
      <>
        {this.state.uploadError ? <p className="surveyErrorText">There was an error uploading your image. Please try again and make sure you are using an image.</p> : null}
        <div className="surveyOptionContainer">
          <div>
            <label htmlFor="s3-uploader" className="s3-uploader-label">Click here to upload a file</label>
            <p>{this.displayImportFileStatus()}</p>
            <ReactS3Uploader
              style={{ display: 'none' }}
              id="s3-uploader"
              inputRef={this.s3Uploader}
              signingUrl="/api/s3/sign"
              signingUrlMethod="GET"
              accept="image/*"
              s3path="profile_photos/"
              onError={this.uploadError}
              onFinish={this.uploadSuccess}
              signingUrlHeaders={{ Authorization: localStorage.getItem('token') }}
              uploadRequestHeaders={{ 'x-amz-acl': 'public-read' }} // this is the default
              contentDisposition="auto"
              scrubFilename={filename => filename.replace(/[^\w\d_\-.]+/ig, '')}
              server={config.url}
              preprocess={(file, next) => {
                this.setState({ uploading: true });
                next(file);
              }}
              autoUpload
            />
          </div>
        </div>
      </>
    );
  }

  renderSlider = () => {
    const scores = Array.from({ length: 5 }, (x, i) => i - 2);
    const opt1 = this.props.options[0];
    const opt2 = this.props.options[1];
    return (
      <div className="surveyOptionContainer">
        <div className="sliderContainer">
          <p className="surveyOptionText1">{opt1}</p>
          {scores.map((val) => {
            let className;
            switch (Math.abs(val)) {
              case 2:
                className = 'sliderBigBubble';
                break;
              case 1:
                className = 'sliderMediumBubble';
                break;
              default:
                className = 'sliderSmallBubble';
            }
            return (
              <div
                role="button"
                tabIndex={0}
                key={val}
                className={`sliderBubble ${className} ${this.isSelected(val) && 'surveySelected'}`}
                onClick={() => this.props.optionSelected(this.props.surveyQuestions, this.props.name, this.props.type, val)}
              />
            );
          })}
          <p className="surveyOptionText2">{opt2}</p>
        </div>
      </div>
    );
  }

  renderCheckboxes = () => {
    return this.props.options.map((option, i) => {
      return (
        <div className="checkContainer" key={i}>
          <div className="surveyOptionContainerCheck" key={i}>
            <div
              role="button"
              tabIndex={0}
              className={`surveyCheckbox ${this.isSelected(option) && 'surveySelected'}`}
              onClick={() => this.props.optionSelected(this.props.surveyQuestions, this.props.name, this.props.type, option)}
            />
            <p className="surveyOptionText">{option}</p>
          </div>
        </div>
      );
    });
  }

  renderOptions = (questionType) => {
    switch (questionType) {
      case 'short':
        return (this.renderShortAnswer());
      case 'multiple':
        return (this.renderMultiple());
      case 'slider':
        return (this.renderSlider());
      case 'checkbox':
        return (this.renderCheckboxes());
      case 'import':
        return (this.renderImport());
      default:
        return null;
    }
  }

  render() {
    return (
      <div className="surveyQuestionContainer">
        <p
          className="surveyQuestionTitle"
        >
          {`${this.props.title}${
            !this.props.required
              ? ''
              : '*'
          }`}
        </p>
        {this.props.displayErrors && this.props.isBlank(this.props.name) && <p className="surveyErrorText">*This question cannot be left blank</p>}
        <div className="answerBox">
          {this.renderOptions(this.props.type)}
        </div>
      </div>
    );
  }
}

export default SurveyQuestion;
